/* eslint-disable import/no-anonymous-default-export */

import error from './es-ES/error';
import exception from './es-ES/exception';
import field from './es-ES/field';
import general from './es-ES/general';
import project from './es-ES/project';
import projectItem from './es-ES/projectItem';

export default {
  ...general,
  ...field,
  ...project,
  ...projectItem,
  ...error,
  ...exception,
};

